import clsx from "clsx";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={clsx(
        "animate-pulse rounded-md bg-zinc-100 dark:bg-zinc-900",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
